import React, { useEffect, useRef } from "react";

/**
 * Usage:
 * The callback sends Telegram's signed fields directly to the session provider,
 * which exchanges them for a secure cookie without retaining a Telegram ID in browser storage.
 */
export default function TelegramIdLogin({ mode = "callback", onTelegramPayload }) {
  const ref = useRef(null);

  useEffect(() => {
    const containerRef = ref.current;
    if (!containerRef) return;

    containerRef.innerHTML = "";

    // Clear any cached Telegram widget data
    // This helps when browser caches prevent redirect from working
    if (window.Telegram && window.Telegram.Login) {
      delete window.Telegram.Login;
    }

    window.onTelegramAuth = (user) => {
      // Keep sync: sometimes Telegram passes non-object; only dispatch when user is a valid object
      const isUserObject = user && typeof user === "object" && !Array.isArray(user) && typeof user.id !== "undefined" && user.auth_date != null && user.hash;
      if (!isUserObject) return;
      onTelegramPayload?.({ mode: "WIDGET", fields: user });
    };

    // Add cache-busting timestamp to prevent browser from using cached script
    const timestamp = Date.now();
    const script = document.createElement("script");
    script.async = true;
    // Cache-busting: add timestamp to force fresh script load
    script.src = `https://telegram.org/js/telegram-widget.js?22&_=${timestamp}`;
    script.setAttribute("data-telegram-login", "CryptemberBot"); // bot username without @
    script.setAttribute("data-size", "large");
    if (mode === "callback") {
      script.setAttribute("data-onauth", "onTelegramAuth(user)");
    } else {
      // Add timestamp to auth-url to prevent browser from blocking redirect due to cached response
      script.setAttribute("data-auth-url", `https://insights.cryptember.com?t=${timestamp}`);
    }
    //script.setAttribute("data-userpic", "true");
    script.setAttribute("data-request-access", "write");
    //script.setAttribute("data-onauth", "onTelegramAuth(user)");
    //script.setAttribute("unsafe-eval", "true");

    // Force script to reload (prevent browser caching)
    script.setAttribute("crossorigin", "anonymous");

    containerRef.appendChild(script);

    return () => {
      // Cleanup
      if (containerRef) {
        containerRef.innerHTML = "";
      }
    };
  }, [mode, onTelegramPayload]);

  return (<div ref={ref} />);
}
